export default "__VITE_ASSET__rmfkdaRt__"